export const AUTHENTICATED_HOME = "/dashboard";
export const NOT_AUTHENTICATED_HOME = "/login";


// WEBPACK FOOTER //
// ./src/routes/constants.js